export default {
    D002: 'FILE_MISSING',
    D003: 'SIZE_LIMIT',
};
